import { Injectable } from '@angular/core';
import { FC_MotherVideo } from '../funcionesCompatibilidad/FC_MotherVideo';
import { FC_VideoFuente } from '../funcionesCompatibilidad/FC_VideoFuente';
import { FC_VideoGabinete } from '../funcionesCompatibilidad/FC_VideoGabinete';
import { Incompatibilities } from '../Incompatibilities';
import { PlacaVideo } from '../model';
import { DataArmado } from './DataArmado';
import { FuncionesArmadoBase } from './FuncionesArmadoBase';
import { IncompatibilitiesType } from '@core/enums/incompatibilities-types.enum';
@Injectable({
  providedIn: 'root',
})
export class FA_Video extends FuncionesArmadoBase<PlacaVideo> {
  constructor(
    private fc_motherVideo: FC_MotherVideo,
    private fc_videoFuente: FC_VideoFuente,
    private fc_videoGabinete: FC_VideoGabinete,
  ) {
    super();
  }
  funciones = {
    // TODO: si la placa es incompatible con la mother debería tener solo una incompatibilidad e ignorar la de cantidad
    cantidad: (dataArmado: DataArmado, video: PlacaVideo): Incompatibilities[] => {
      let tipoVideo = video.$caracteristicas.tipo;
      let cantidadMaxima = 2;
      let mother = dataArmado.mother[0];
      let cantidadSeleccionada = dataArmado.placasVideos.length;
      if (mother) {
        cantidadMaxima =
          mother.$caracteristicas[tipoVideo.includes('pcie') ? 'nro_pcie' : tipoVideo];
      }
      if (cantidadSeleccionada > cantidadMaxima)
        return [
          {
            tipo: IncompatibilitiesType.ARMADO,
            incompatibility: 'Excede la cantidad máxima de placas de video',
          },
        ];

      if (cantidadSeleccionada == cantidadMaxima) {
        if (dataArmado.placasVideos.some((v) => v.id_producto == video.id_producto)) {
          return [
            {
              tipo: IncompatibilitiesType.DEFAULT_STOCK,
              incompatibility: '',
            },
          ];
        }
        return [
          {
            tipo: IncompatibilitiesType.CANTIDAD,
            incompatibility:
              mother ?
                'La mother no soporta otra placa de video'
              : 'Excede la cantidad máxima de placas de video',
          },
        ];
      }
      return null;
    },
    mother: (dataArmado: DataArmado, video: PlacaVideo) => {
      const motherEnArmado = dataArmado.mother[0];
      if (!motherEnArmado) return [];
      return this.fc_motherVideo.ejecutar(motherEnArmado, video);
    },
    fuente: (dataArmado: DataArmado, video: PlacaVideo) => {
      const gabinete = dataArmado.gabinetes[0];
      const fuenteEnArmado = dataArmado.fuentes[0];
      if (!fuenteEnArmado) {
        if (gabinete?.$caracteristicas?.kit == 1 && gabinete?.$caracteristicas?.id_fuente > 0) {
          return this.fc_videoFuente.ejecutar(
            video,
            gabinete.$caracteristicas.$caracteristicas_fuente,
          );
        }
        return [];
      }
      return this.fc_videoFuente.ejecutar(video, fuenteEnArmado);
    },
    capacidadPinesFuente: (
      dataArmado: DataArmado,
      video: PlacaVideo,
    ): Incompatibilities[] | null => {
      // se genera objeto local de fuente
      let fuente = dataArmado.fuentes[0];
      if (!fuente) {
        const gabinete = dataArmado.gabinetes[0];
        if (gabinete?.$caracteristicas?.kit == 1 && gabinete?.$caracteristicas?.id_fuente > 0) {
          fuente = gabinete.$caracteristicas.$caracteristicas_fuente;
        } else {
          return null;
        }
      }
      let $fuente = {
        _16pines: fuente.$caracteristicas.pcie_16pines,
        pcie: fuente.$caracteristicas.pines_pcie,
        pcieplus: fuente.$caracteristicas.pines_pcieplus,
      };

      // se genera objeto local de placa de video
      const $placa = {
        _16pines: video.$caracteristicas._16pines || 0,
        _16pines_adaptadores: video.$caracteristicas.adaptador_16pines || 0,
        _16pinesCantidadConexion: video.$caracteristicas._16pines_conexion || 0,
        _16pinesCablesPorAdaptador:
          video.$caracteristicas.adaptador_16pines ||
          0 * video.$caracteristicas._16pines_conexion ||
          0,
        _2plusNecesarios: video.$caracteristicas._2plus || 0,
        _6pinesNecesarios: video.$caracteristicas._6pines || 0,
      };

      // en caso de que SI se tengan los 16 pines en video
      if ($placa._16pines) {
        // se restan los pines de la fuente a los de la placa para saber cuantos adaptadores necesito
        let adaptadoresNecesarios = $placa._16pines - $fuente._16pines;

        // estas son las cantidades de conexiones de la fuente
        let cantidadConexionesFuente = Math.min($fuente.pcie, $fuente.pcieplus);

        // si los adaptadores de la placa no son los necesarios para cubrir a la fuente

        if ($placa._16pines_adaptadores < adaptadoresNecesarios) {
          return [
            {
              tipo: IncompatibilitiesType.PRODUCTO,
              incompatibility: 'Pines de fuente insuficientes',
            },
          ];
        }
        // si los adaptadores de la placa SI son los necesarios para cubrir a la fuente
        else {
          // se chequean las cantidades de conexiones de la fuente, y si son menores que los de la placa tira incompatibilidad

          if (cantidadConexionesFuente < $placa._16pinesCantidadConexion) {
            return [
              {
                tipo: IncompatibilitiesType.PRODUCTO,
                incompatibility: 'Pines de fuente insuficientes',
              },
            ];
          }
        }
      }
      // en el caso de que no se tengan los 16 pines en video
      else {
        if (
          $fuente.pcieplus >= $placa._2plusNecesarios &&
          $fuente.pcie >= $placa._6pinesNecesarios
        ) {
          return null;
        } else {
          return [
            {
              tipo: IncompatibilitiesType.PRODUCTO,
              incompatibility: 'Pines de fuente insuficientes',
            },
          ];
        }
      }
      return null;
    },
    gabinete: (dataArmado: DataArmado, video: PlacaVideo) => {
      const gabineteEnArmado = dataArmado.gabinetes[0];
      if (!gabineteEnArmado) return [];
      return this.fc_videoGabinete.ejecutar(video, gabineteEnArmado);
    },
  };
}
